import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Disabled from "components/common/Disabled";
import StatusBadgeV2 from "components/common/StatusBadgeV2";
import * as staticDataService from "services/staticDataService";

const NULL_KEY = "__NULL__";

const StatusOverrideSelector = ({
  program,
  updateProgram,
  label = "Status Override",
}) => {
  const { data: statusLabels } = staticDataService.useConfigQuery(
    "layer_status_labels_v2"
  );

  return (
    <Disabled ifReadOnly>
      <FormControl variant={"filled"} fullWidth>
        <InputLabel shrink={true}>{label}</InputLabel>
        <Select
          value={program?.status ?? NULL_KEY}
          onChange={(event) => {
            const status = event.target.value;
            updateProgram({
              status: status === NULL_KEY ? null : status,
            });
          }}
        >
          <MenuItem value={NULL_KEY} sx={{ minHeight: "26px !important" }}>
            <Typography variant={"caption"} sx={{ fontWeight: 600 }}>
              {program?.status == null ? "" : "Clear Override"}
            </Typography>
          </MenuItem>
          <Divider />
          {(statusLabels?.labels ?? []).map(({ statusKey }, index) =>
            statusKey === "DIVIDER" ? (
              <Divider key={`divider-${index}`} />
            ) : (
              <MenuItem key={statusKey} value={statusKey}>
                <StatusBadgeV2 status={statusKey} />
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
    </Disabled>
  );
};

export default StatusOverrideSelector;
